<template>
  <div>

    <b-overlay :show="requestProgress">
      <b-row>
        <b-col
            v-if="request"
            md="8"
            lg="8"
        >
          <b-card
              :id="`request-${request.id}`"
              :ref="`request${request.id}`"
              class=" card-app-design"
          >
            <b-card-header class="pb-1">

              <b-media no-body>
                <b-media-body>
                  <h5 class="mb-0">
                    {{ request.creator.name }}
                  </h5>
                  <small class="text-muted">{{ request.createdDate }}</small>
                </b-media-body>
              </b-media>
              <span>عنوان درخواست: <strong>{{ request.process.title }}<small
                  v-if="request.process.parent"
              >({{ request.process.parent.title }})</small></strong></span>
              <span class="text-muted"> شماره درخواست: {{ request.id }}</span>
            </b-card-header>

            <b-card-title class="mt-1 mb-75">
              موضوع: {{ request.title }}

            </b-card-title>

            <b-card-text v-html="request.description"/>
            <b-list-group v-if="request && request.fields.length > 0">
              <b-list-group-item
                  v-for="(field,index) in request.fields"
                  :key="index"
              ><strong>{{
                  field.title
                }}: </strong> {{ field.value }}
              </b-list-group-item>
            </b-list-group>
            <b-card-footer v-if="request.attachments && request.attachments.length">
              <div class="mail-attachments mt-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                      icon="PaperclipIcon"
                      size="16"
                  />
                  <h5 class="font-weight-bolder text-body mb-0 ml-50">
                    فایل{{ request.attachments.length > 1 ? ' ها' : '' }}
                    {{ request.attachments.length }}
                  </h5>
                </div>
                <div class="d-flex flex-column">
                  <b-link
                      v-for="(attachment, index) in request.attachments"
                      :key="index"
                      :href="attachment.url"
                      target="_blank"
                      :class="{'mt-75': index}"
                  >
                                        <span class="text-muted font-weight-bolder align-text-top">{{
                                            attachment.fileName
                                          }}</span>
                    <span class="text-muted font-small-2 ml-25">({{ attachment.size }})</span>
                  </b-link>

                </div>
              </div>
            </b-card-footer>

          </b-card>
        </b-col>
        <b-col cols="8">
          <b-alert
              v-if="mainProcess==49"
              variant="info"
              show
              class="text-center py-1 mb-2"
          >
            <div class="alert-body" v-if="remainVacation" style="font-size: 16px">
              <span>باقی مانده مرخصی شما:</span>
              <strong style="display: inline-block; margin-right: 10px">{{`${remainVacation.remain_days} روز و ${remainVacation.remain_hours} ساعت`}}</strong>
              <span style="display: block">{{ `اخرین اپدیت مانده مرخصی ها: ${remainVacation.updated_at}` }}</span>
            </div>
          </b-alert>
        </b-col>
      </b-row>
      <b-row>

        <b-col
            md="7"
            lg="7"
        >

          <div ref="repliesList">
            <b-card
                v-for="comment in comments"
                :id="`request-${comment.id}`"
                :ref="`request${comment.id}`"
                :key="comment.id"
                no-body
                class="mb-4"
            >
              <b-card-header
                  class="email-detail-head"
              >
                <div class="user-details d-flex justify-content-between align-items-center flex-wrap">
                  <b-avatar
                      size="48"
                      :show="comment.user.avatar"
                      :src="comment.user.avatar"
                      class="mr-75"
                  />
                  <div class="mail-items">
                    <h5 class="mb-0">
                      {{ `${comment.status} توسط: ${comment.user.name}` }}
                    </h5>
                  </div>
                </div>
                <div class="mail-meta-item d-flex align-items-center">
                  <small class="mail-date-time text-muted"
                         :title="`تاریخ ایجاد: ${comment.createdDate}`"
                         v-b-tooltip.hover.v-primary>
                    <bdi>{{ comment.updatedDate }}</bdi>
                  </small>
                  <!-- Mail Action DD -->
                </div>
              </b-card-header>

              <b-card-body class="mail-message-wrapper pt-2">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="mail-message"
                    v-html="comment.description"
                />
                <!-- eslint-enable -->
              </b-card-body>

              <b-card-footer v-if="comment.attachments && comment.attachments.length">
                <div class="mail-attachments">
                  <div class="d-flex align-items-center mb-1">
                    <feather-icon
                        icon="PaperclipIcon"
                        size="16"
                    />
                    <h5 class="font-weight-bolder text-body mb-0 ml-50">
                      فایل {{ comment.attachments.length > 1 ? 'ها' : '' }}
                      {{ comment.attachments.length }}
                    </h5>
                  </div>

                  <div class="d-flex flex-column">
                    <b-link
                        v-for="(attachment, index) in comment.attachments"
                        :key="index"
                        :href="attachment.url"
                        target="_blank"
                        :class="{'mt-75': index}"
                    >

                                            <span class="text-muted font-weight-bolder align-text-top">{{
                                                attachment.fileName
                                              }}</span>
                      <span class="text-muted font-small-2 ml-25">({{ attachment.size }})</span>
                    </b-link>
                  </div>
                </div>
              </b-card-footer>
            </b-card>
            <b-card
                no-body
                class="mb-4 bg-gradient-secondary"
                v-if="request && request.waitingFor"
            >
              <b-card-header
                  class="email-detail-head"
              >
                <div class="user-details d-flex justify-content-between align-items-center flex-wrap">
                  <div class="mail-items">
                    <h5 class="mb-0 text-white">
                      {{ request.waitingFor.status }}
                    </h5>
                  </div>
                </div>
                <div class="mail-meta-item d-flex align-items-center">
                  <small class="mail-date-time text-white">
                    <bdi>{{ request.waitingFor.createdDate }}</bdi>
                  </small>
                </div>
              </b-card-header>

              <b-card-body class="mail-message-wrapper pt-2">
                <div>
                  <b-overlay
                      :show="true"
                      rounded="lg"
                      opacity="0.6"
                  >
                    <template v-slot:overlay>
                      <div class="d-flex align-items-center">
                        <b-spinner
                            small
                            type="grow"
                            variant="info"
                        />
                        <span class="sr-only">{{ request.waitingFor.status }}...</span>
                      </div>
                    </template>
                  </b-overlay>
                </div>
              </b-card-body>
            </b-card>
            <b-card
                v-if="request && request.currentComment"
                class="mb-4"
            >

              <b-card-text>
                <b-form>

                  <b-row>
                    <b-col md="12">
                      <b-form-group
                          label="توضیحات"
                      >
                        <div>
                          <quill-editor
                              v-model="content"
                              :options="editorOption"
                              style="min-height:150px;"
                          />
                        </div>

                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row
                      v-for="(item, index) in attachment.items"
                      :id="item.id"
                      :key="item.id"
                  >
                    <!-- Item Name -->
                    <b-col
                        md="9"
                        lg="9"
                    >
                      <b-form-group>
                        <label :for="`attachment_${item.id}`">
                          <feather-icon
                              icon="PaperclipIcon"
                          />
                          فایل
                        </label>
                        <b-form-file
                            v-model="item.file"
                            placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                            drop-placeholder="عکس را به اینحا بکشید"
                            no-drop
                        />
                      </b-form-group>
                    </b-col>

                    <!-- Remove Button -->
                    <b-col
                        lg="3"
                        md="3"
                        class="mb-50"
                    >
                      <b-button
                          variant="outline-danger"
                          class="mt-0 mt-md-2"
                          @click="removeItem(index)"
                      >
                        <feather-icon
                            icon="XIcon"
                            class="mr-25"
                        />
                        <span>حذف فایل</span>
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      <hr>
                    </b-col>
                  </b-row>
                  <b-button
                      variant="primary"
                      @click="repeateAgain"
                  >
                    <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                    />
                    <span>افزودن فایل</span>
                  </b-button>

                </b-form>

              </b-card-text>

              <div class="demo-inline-spacing float-right">
                <b-button
                    variant="outline-success"
                    size="sm"
                    @click="processRequest('accept')"
                >
                  تأیید درخواست
                </b-button>

                <b-button
                    class="mr-2"
                    variant="outline-primary"
                    size="sm"
                    @click="processRequest('review')"
                >
                  نیاز به بازنگری
                </b-button>

                <b-button
                    class="mr-2"
                    variant="outline-danger"
                    size="sm"
                    @click="rejectRequest"
                >
                  رد درخواست
                </b-button>
              </div>

            </b-card>

          </div>
          <!--        </b-overlay>-->
        </b-col>
      </b-row>
    </b-overlay>

  </div>

</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BCardTitle,
  BSpinner,
  BButton,
  BCardText,
  BLink,
  BListGroup,
  BListGroupItem,
  BAvatar,
  BBadge,
  BFormTextarea,
  BMediaAside,
  BMedia,
  BMediaBody, BFormFile, BImg, BCardFooter, BDropdown, BDropdownItem, VBTooltip, BAlert
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {quillEditor} from 'vue-quill-editor'
import {formatDate} from '@core/utils/filter'
import {doubleRaf} from '@/libs/utils'
import store from '@/store'
import {DEFAULT_ANSWER_HTML, answerTextFor} from './answerText'

export default {
  name: 'RequestDetail',
  components: {
    BAlert,
    BDropdownItem,
    BDropdown,
    BCardFooter,
    BImg,
    BFormFile,
    BMediaBody,
    BMedia,
    BMediaAside,
    BFormTextarea,
    BBadge,
    BAvatar,
    BListGroupItem,
    BListGroup,
    BLink,
    BCardText,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BCardTitle,
    BSpinner,
    BButton,
    quillEditor,

  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== from.params.id) {
      this.getRequest(to.params.id)
    }
    next();
  },
  data() {
    return {
      request: null,
      requestProgress: false,
      comments: [],
      onProgress: false,
      requestId: null,
      receivers: [],
      content: DEFAULT_ANSWER_HTML,
      forwardContent: '',
      receiversList: [],
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{direction: 'rtl'}],
            [{header: [1, 2, 3, 4, 5, 6, false]}],

            [{color: []}, {background: []}],
            [{align: []}],

            ['clean'],
          ],
        },
        theme: 'snow',
        placeholder: 'متن پیام را وارد کنید',
        clipboard: true,
      },
      sms: '',
      prioritiesList: [],
      priority: '',
      attachment: {
        items: [
          {
            id: 1,
            file: null,
          },
        ],
        nextItemId: 2,
      },
      loading: true,
      maxChar: 140,
      showReplyModal: false,
      showForwardModal: false,
      mainProcess:null,
      remainVacation:null,
    }
  },
  watch: {
    mainProcess(newValue, oldValue) {
      if (newValue !== null) {
        if (newValue === 49) {
          this.$http.get(`${this.request?.signed_url}`).then(response => {
            this.remainVacation = response.data.data
          })
        }
      }
    },
  },
  computed: {
    closeVariant() {
      return this.request.isClosed ? 'secondary' : 'danger'
    },
    closeButtonText() {
      return this.request.isClosed ? 'بسته شده' : 'بستن درخواست'
    },
  },
  mounted() {
    this.getRequest()
  },
  methods: {
    repeateAgain() {
      this.attachment.nextItemId++
      this.attachment.items.push({
        id: this.attachment.nextItemId,
        file: null,
      })
    },
    removeItem(index) {
      this.attachment.items.splice(index, 1)
    },
    async getRequest(id = null) {
      this.requestProgress = true
      await this.$http.get(`requests/${id ?? this.$route.params.id}`)
          .then(({data}) => {
            if (data.status) {
              this.request = data.request
              this.mainProcess = data.request.process.parent.id
              this.comments = data.request.comments ?? []
              this.loading = false
            } else {
              this.$bvToast.toast(data.message ?? 'اطلاعات درخواست دریافت نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast((error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد'), {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })

      doubleRaf(() => {
        this.requestProgress = false
      })
    },

    scrollTo(ref) {
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].scrollIntoView({behavior: 'smooth'})
      } else {
        this.$refs[ref].scrollIntoView({behavior: 'smooth'})
      }
    },
    scrollToLastRequest(refName) {
      doubleRaf(() => {
        const dynamicContainer = this.$refs.repliesList
        const lastElement = dynamicContainer.lastElementChild
        lastElement.scrollIntoView({behavior: 'smooth'})
      })
    },

    async processRequest(action) {
      if (this.request.currentComment !== null) {
        if (this.content === '') {
          this.$bvToast.toast('متن پاسخ نمی تواند خالی باشد', {
            title: 'خطا',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
          return false
        }

        const content = await answerTextFor(this.$swal, this.content, action)
        if (content === null) {
          return false
        }
        this.content = content

        let title = ''
        switch (action) {
          case 'accept':
            title = 'تأیید'
            break
          case 'reject':
            title = 'بازنگری'
            break
        }

        this.onProgress = true

        const formReplyData = new FormData()

        formReplyData.append('comment_id', this.request.currentComment.id)
        formReplyData.append('content', this.content)

        this.attachment.items.map(attachment => {
          formReplyData.append('attachments[]', attachment.file)
        })

        this.$http.post(`requests/${this.$route.params.id}/${action}`, formReplyData, {
          header: [
            'Content-Type:multipart/form-data',
          ],
        })
            .then(({data}) => {
              if (data.status) {
                this.$http.get('requests/notification')
                    .then(({data}) => {
                      store.commit('request/ADD_REQUEST_TO_LIST', data)
                    })
                this.content = DEFAULT_ANSWER_HTML
                this.attachment = {
                  items: [
                    {
                      id: 1,
                      file: null,
                    },
                  ],
                  nextItemId: 2,
                }
                this.request.comments.push(data.comment)
                this.request.currentComment = data.currentComment
                this.scrollToLastRequest(`request${data.comment.id}`)

                this.$bvToast.toast(`درخواست ${title} شد`, {
                  title: 'انجام درخواست',
                  toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                  variant: 'success',
                })
              } else {
                this.$bvToast.toast(`${title} درخواست انجام نشد`, {
                  title: 'حطا',
                  toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                  variant: 'danger',
                })
              }
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.message ?? `${error.message}`, {
                title: 'خطا در دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            })
            .finally(() => {
              this.onProgress = false
              this.$router.push({name: "Requests_Inbox"})
            })
      }
    },

    acceptRequest() {
      if (this.request.currentComment !== null) {
        if (this.content === '') {
          this.$bvToast.toast('متن پاسخ نمی تواند خالی باشد', {
            title: 'خطا',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
          return false
        }

        this.onProgress = true

        const formReplyData = new FormData()

        formReplyData.append('comment_id', this.request.currentComment.id)
        formReplyData.append('content', this.content)

        this.attachment.items.map(attachment => {
          formReplyData.append('attachments[]', attachment.file)
        })

        this.$http.post(`requests/${this.$route.params.id}/accept`, formReplyData, {
          header: [
            'Content-Type:multipart/form-data',
          ],
        })
            .then(({data}) => {
              if (data.status) {
                this.content = DEFAULT_ANSWER_HTML
                this.attachment = {
                  items: [
                    {
                      id: 1,
                      file: null,
                    },
                  ],
                  nextItemId: 2,
                }
                this.request.comments.push(data.comment)
                this.request.currentComment = data.currentComment
                this.scrollToLastRequest(`request${data.comment.id}`)

                this.$bvToast.toast('درخواست تأیید شد', {
                  title: 'انجام درخواست',
                  toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                  variant: 'success',
                })
              } else {
                this.$bvToast.toast(data.message ?? 'تأیید درخواست انجام نشد', {
                  title: 'حطا',
                  toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                  variant: 'danger',
                })
              }
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.message ?? `${error.message}`, {
                title: 'خطا در دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            })
            .finally(() => {
              this.onProgress = false
            })
      }
    },

    async rejectRequest() {
      if (this.request.currentComment !== null) {
        if (this.content === '') {
          this.$bvToast.toast('متن پاسخ نمی تواند خالی باشد', {
            title: 'خطا',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
          return false
        }

        const content = await answerTextFor(this.$swal, this.content, 'reject')
        if (content === null) {
          return false
        }
        this.content = content

        this.onProgress = true

        const formRejectData = new FormData()

        formRejectData.append('comment_id', this.request.currentComment.id)
        formRejectData.append('content', this.content)

        this.attachment.items.map(attachment => {
          formRejectData.append('attachments[]', attachment.file)
        })

        this.$http.post(`requests/${this.$route.params.id}/reject`, formRejectData, {
          header: [
            'Content-Type:multipart/form-data',
          ],
        })
            .then(({data}) => {
              if (data.status) {
                this.$http.get('requests/notification')
                    .then(({data}) => {
                      store.commit('request/ADD_REQUEST_TO_LIST', data)
                    })
                this.content = DEFAULT_ANSWER_HTML
                this.attachment = {
                  items: [
                    {
                      id: 1,
                      file: null,
                    },
                  ],
                  nextItemId: 2,
                }
                this.request.comments.push(data.comment)
                this.request.currentComment = data.currentComment
                this.scrollToLastRequest(`request${data.comment.id}`)

                this.$bvToast.toast('درخواست رد شد', {
                  title: 'رد درخواست',
                  toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                  variant: 'success',
                })
              } else {
                this.$bvToast.toast(data.message ?? 'رد درخواست انجام نشد', {
                  title: 'حطا',
                  toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                  variant: 'danger',
                })
              }
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.message ?? `${error.message}`, {
                title: 'خطا در دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            })
            .finally(() => {
              this.onProgress = false
            })
      }
    },

    async forwardForm(bvModalEvt) {
      bvModalEvt.preventDefault()

      if (this.receivers.length === 0) {
        this.$bvToast.toast('کاربران اراجاع دهنده نمی تواند خالی باشد', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }

      this.onProgress = true

      const formForwardData = new FormData()

      formForwardData.append('model', 'forward')
      formForwardData.append('forward_id', this.requestId)
      formForwardData.append('content', this.forwardContent)
      formForwardData.append('sms', this.sms)
      formForwardData.append('priority', this.priority)
      this.receivers.map(receiver => {
        formForwardData.append('receivers[]', receiver)
      })
      this.attachment.items.map(attachment => {
        formForwardData.append('attachments[]', attachment.file)
      })

      await this.$http.post(`requests/${this.request.id}/forward`, formForwardData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
          .then(({data}) => {
            if (data.status) {
              this.showReplyModal = false

              this.forwardContent = ''
              this.sms = ''
              this.attachment = {
                items: [
                  {
                    id: 1,
                    file: null,
                  },
                ],
                nextItemId: 2,
              }
              this.priority = ''

              this.references = data.references

              this.$bvToast.toast('ارجاع با موفقیت ارسال شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
            } else {
              this.$bvToast.toast(data.message ?? 'ارجاع ارسال نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
            bvModalEvt.hide()
          })
    },

    getRelatedUsers() {
      this.$http.get('requests/related-users')
          .then(({data}) => {
            if (data.status) {
              this.receiversList = data.users
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست دریافت کنندگان با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    getPriorities() {
      this.$http.get('requests/priorities')
          .then(({data}) => {
            if (data.status) {
              this.prioritiesList = data.priorities
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست اولویت ها با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },

    cancelForm() {
      this.content = ''
      this.forwardContent = ''
      this.sms = ''
      this.attachment = {
        items: [
          {
            id: 1,
            file: null,
          },
        ],
        nextItemId: 2,
      }
      this.priority = ''
    },

    closeRequest() {
      this.$swal({
        title: 'هشدار!',
        text: 'از بستن درخواست اطمینان دارید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'بله، مطمئنم',
        cancelButtonText: 'منصرف شدم',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
              this.$http.post(`requests/${this.request.id}/close`)
                  .then(({data}) => {
                    if (data.status) {
                      this.request.isClosed = true
                      this.$swal({
                        icon: 'success',
                        title: 'بسته شد.',
                        text: 'درخواست با موفقیت بسته شد.',
                        customClass: {
                          confirmButton: 'btn btn-success',
                        },
                      })
                    } else {
                      this.$swal({
                        icon: 'error',
                        title: 'خطا!',
                        confirmButtonText: 'متوجه شدم!',
                        text: data.message ?? 'مشکلی در انجام عملیات رخ داده است.',
                        customClass: {
                          confirmButton: 'btn btn-danger',
                        },
                      })
                    }
                  })
            }
          })
    },
  },
  setup() {
    return {
      formatDate,
    }
  },
}
</script>

<style>
.ql-container {
  min-height: inherit;
}

.email-detail-head {
  border-bottom: 1px solid #ebe9f1 !important;
}
</style>
